// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Button } from '@/components/ui/button';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { toast } from 'sonner';
// import axios from 'axios';
// import { FileText } from 'lucide-react';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Login = ({ onLogin }) => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await axios.post(`${API}/auth/login`, { email, password });
//       toast.success('Login successful!');
//       onLogin(response.data.access_token);
//       navigate('/');
//     } catch (error) {
//       toast.error(error.response?.data?.detail || 'Login failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-background flex items-center justify-center p-4">
//       <div className="w-full max-w-md">
//         <div className="bg-card rounded-2xl shadow-hover p-8 border border-border">
//           <div className="flex items-center justify-center mb-8">
//             <div className="bg-primary/10 p-4 rounded-xl">
//               <FileText className="w-10 h-10 text-primary" />
//             </div>
//           </div>

//           <h1 className="text-3xl font-bold text-center mb-2">Welcome Back</h1>
//           <p className="text-center text-muted-foreground mb-8">Sign in to your account</p>

//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div className="space-y-2">
//               <Label htmlFor="email">Email</Label>
//               <Input
//                 id="email"
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 placeholder="you@example.com"
//                 data-testid="login-email-input"
//                 className="bg-white"
//               />
//             </div>

//             <div className="space-y-2">
//               <Label htmlFor="password">Password</Label>
//               <Input
//                 id="password"
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 placeholder="••••••••"
//                 data-testid="login-password-input"
//                 className="bg-white"
//               />
//             </div>

//             <Button
//               type="submit"
//               className="w-full"
//               disabled={loading}
//               data-testid="login-submit-button"
//             >
//               {loading ? 'Signing in...' : 'Sign In'}
//             </Button>
//           </form>

//           <p className="text-center text-sm text-muted-foreground mt-6">
//             Don't have an account?{' '}
//             <Link to="/signup" className="text-primary font-medium hover:underline">
//               Sign up
//             </Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { FileText } from 'lucide-react';

// 🔥 Firebase imports
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // adjust path if needed

// ❌ Not needed anymore for Firebase login
// import axios from 'axios';
// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // You can pass user or token up if needed
      onLogin?.(user);

      toast.success('Login successful!');
      navigate('/');
    } catch (error) {
      console.error('Firebase login error:', error);

      let msg = 'Login failed';
      if (error.code === 'auth/user-not-found') msg = 'User not found';
      if (error.code === 'auth/wrong-password') msg = 'Incorrect password';
      if (error.code === 'auth/invalid-email') msg = 'Invalid email';

      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-2xl shadow-hover p-8 border border-border">
          <div className="flex items-center justify-center mb-8">
            <div className="bg-primary/10 p-4 rounded-xl">
              <FileText className="w-10 h-10 text-primary" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-center mb-2">Welcome Back</h1>
          <p className="text-center text-muted-foreground mb-8">
            Sign in to your account
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                data-testid="login-email-input"
                className="bg-white"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                data-testid="login-password-input"
                className="bg-white"
              />
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

    
        </div>
      </div>
    </div>
  );
};

export default Login;
